import { IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TablePaginationActionsProps } from '@material-ui/core/TablePagination/TablePaginationActions';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },

  controls: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    left: 0,
    top: 0,
    paddingLeft: 4,
    paddingTop: 9,
  },

  pageLabel: {
    display: 'inline-flex',
    color: '#666',
  },
}));

const TablePaginationActions = (paginationProps: TablePaginationActionsProps): JSX.Element => {
  const classes = useStyles();

  const { count, page, rowsPerPage, onChangePage } = paginationProps;

  const from = page * rowsPerPage + 1;
  const to = (page + 1) * rowsPerPage;

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <Typography variant="caption" className={classes.pageLabel}>{`${from}-${to > count ? count : to} of ${
        count !== -1 ? count : `more than ${to}`
      }`}</Typography>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        <LastPageIcon />
      </IconButton>
    </div>
  );
};

export default TablePaginationActions;
